export default function ClinicBubble(props) {
    return (
        <div className = "clinic-bubble" style = 
        {{
            // padding: '20px', 
            // border: 'solid', 
            // borderStyle: 'solid', 
            // borderColor: 'rgba(255, 255, 255, 0.3)', 
            // borderRadius: '7px', 
            // borderWidth: '1px', 
            width: '100%', 
            boxSizing: 'border-box',
            width: '90%',
            paddingLeft: '20px',
            marginRight: props.user == 'KC Social Nest' ? 'auto' : '0px',
            transitionDuration: '.4s'

        }}>
            <a href = {props.link}>{props.title}
                <p style = {{color: 'rgba(255, 255, 255, 0.52)'}}>{props.link}</p>
                <p style = {{color: 'rgba(255, 255, 255, 0.52)'}}>{props.address}</p>
            </a>
            <p dangerouslySetInnerHTML={{ __html: props.desc }}></p>
        </div>
    )
} 